
/* CASTELLO DEL VINO – BLOGÜBERSICHT V2.3
   Dynamische Kategorien, Navigation ohne Seitenreload
   und blogübergreifende Suche.
*/
(function () {
  "use strict";

  const HUB = "news";
  const VERSION = "2026-10";
  const cache = new Map();

  const BLOGS = `
    query($after:String){
      blogs(first:100,after:$after,sortKey:TITLE){
        nodes { handle title onlineStoreUrl }
        pageInfo { hasNextPage endCursor }
      }
    }
  `;

  const ARTICLES = `
    query($after:String){
      articles(first:100,after:$after,sortKey:PUBLISHED_AT,reverse:true){
        nodes {
          id handle title excerpt content(truncateAt:600)
          publishedAt onlineStoreUrl
          image { url altText }
          blog { handle title }
        }
        pageInfo { hasNextPage endCursor }
      }
    }
  `;

  const normalize = value => String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase("de")
    .trim();

  function create(tag, cls, text) {
    const node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = String(text);
    return node;
  }

  function init(root) {
    if (root.dataset.cdvInitialized === "true") return;

    const $ = selector => root.querySelector(selector);

    const grid = $("[data-cdv-blog-grid]");
    const nav = $("[data-cdv-categories]");
    const form = $("[data-cdv-search-form]");
    const input = $("[data-cdv-search-input]");
    const clear = $("[data-cdv-search-clear]");
    const count = $("[data-cdv-result-count]");
    const heading = $("[data-cdv-results-title]");
    const empty = $("[data-cdv-empty]");
    const status = $("[data-cdv-search-status]");
    const pager = $("[data-cdv-client-pagination]");
    const nativePager = $("[data-cdv-native-pagination]");

    if ([grid, nav, form, input, clear, count, heading,
         empty, status, pager].some(x => !x)) return;

    root.dataset.cdvInitialized = "true";

    const token = (root.dataset.cdvToken || "").trim();
    const domain = root.dataset.cdvDomain || location.hostname;
    const hubUrl = root.dataset.cdvHubUrl || "/blogs/" + HUB;
    const pageSize = Math.max(
      1, Number(root.dataset.cdvPageSize) || 12
    );
    const excerptLength = Math.max(
      80, Number(root.dataset.cdvExcerpt) || 160
    );

    const originalHTML = grid.innerHTML;
    const initialCount = count.textContent;
    const titleEl = $(".cdv-blog__title");

    let selected = root.dataset.cdvCurrent || HUB;
    let all = [];
    let blogs = [];
    let page = 1;
    let ready = false;
    let requestId = 0;

    const sessionKey = "cdv:blog-nav:" + domain;

    const setStatus = message => {
      status.textContent = message;
      status.hidden = !message;
    };

    async function graphQL(query, variables = {}) {
      const headers = {
        "Content-Type": "application/json"
      };

      if (token) {
        headers["X-Shopify-Storefront-Access-Token"] = token;
      }

      const response = await fetch(
        "https://" + domain + "/api/" + VERSION + "/graphql.json",
        {
          method: "POST",
          headers,
          body: JSON.stringify({ query, variables })
        }
      );

      if (!response.ok) {
        throw Error("Storefront API HTTP " + response.status);
      }

      const json = await response.json();

      if (json.errors && json.errors.length) {
        throw Error(
          json.errors.map(error => error.message).join("; ")
        );
      }

      return json.data;
    }

    async function connection(query, key) {
      let next = null;
      let hasNext = true;
      let requests = 0;
      const nodes = [];

      while (hasNext && requests++ < 100) {
        const data = await graphQL(query, { after: next });
        const part = data && data[key];

        if (!part) throw Error("API: " + key + " fehlt");

        nodes.push(...part.nodes);
        hasNext = part.pageInfo.hasNextPage;
        next = part.pageInfo.endCursor;

        if (hasNext && !next) {
          throw Error("API-Cursor fehlt");
        }
      }

      if (hasNext) throw Error("API-Limit erreicht");
      return nodes;
    }

    function loadData() {
      const key = domain + ":" + token;

      if (!cache.has(key)) {
        cache.set(
          key,
          Promise.all([
            connection(BLOGS, "blogs"),
            connection(ARTICLES, "articles")
          ])
          .then(([blogs, articles]) => ({
            blogs,
            articles: articles
              .filter(article => article && article.blog && article.publishedAt)
              .sort((a, b) =>
                new Date(b.publishedAt) - new Date(a.publishedAt)
              )
          }))
          .catch(error => {
            cache.delete(key);
            throw error;
          })
        );
      }

      return cache.get(key);
    }

    const categoryURL = handle =>
      handle === HUB
        ? hubUrl
        : "/blogs/" + encodeURIComponent(handle);

    /* Kategorien erhalten und aktualisieren */
    function renderNav(items) {
      const unique = new Map(
        items
          .filter(blog => blog && blog.handle && blog.title)
          .map(blog => [blog.handle, blog])
      );

      const sorted = [...unique.values()]
        .filter(blog => blog.handle !== HUB)
        .sort((a, b) =>
          a.title.localeCompare(b.title, "de")
        );

      const entries = [
        { handle: HUB, title: "Alle Beiträge" },
        ...sorted
      ];

      const existing = new Map(
        [...nav.querySelectorAll("a[data-cdv-handle]")]
          .map(a => [a.dataset.cdvHandle, a])
      );

      const fragment = document.createDocumentFragment();

      entries.forEach(blog => {
        let link = existing.get(blog.handle);

        if (!link) {
          link = create("a", "cdv-blog__chip", blog.title);
          link.dataset.cdvHandle = blog.handle;
        }

        link.href = categoryURL(blog.handle);
        link.textContent = blog.title;

        const active = blog.handle === selected;
        link.classList.toggle("is-active", active);

        if (active) {
          link.setAttribute("aria-current", "page");
        } else {
          link.removeAttribute("aria-current");
        }

        fragment.appendChild(link);
      });

      nav.replaceChildren(fragment);
    }

    /* Kategorien direkt aus dem Browserspeicher anzeigen */
    try {
      const saved = JSON.parse(
        sessionStorage.getItem(sessionKey) || "null"
      );

      if (Array.isArray(saved)) renderNav(saved);
    } catch (error) {
      // Ohne Cache normal laden.
    }

    /* Blogkarte erstellen */
    function makeCard(article) {
      const card = create("article", "cdv-blog__card");

      const url =
        "/blogs/" + encodeURIComponent(article.blog.handle) +
        "/" + encodeURIComponent(article.handle);

      const photo = create("a", "cdv-blog__card-image-link");
      photo.href = url;
      photo.setAttribute("aria-label", article.title);

      if (article.image && article.image.url) {
        const img = create("img", "cdv-blog__card-image");
        img.src = article.image.url;
        img.alt = article.image.altText || article.title;
        img.loading = "lazy";
        img.decoding = "async";
        photo.appendChild(img);
      } else {
        photo.appendChild(
          create(
            "div",
            "cdv-blog__image-placeholder",
            "CASTELLO DEL VINO"
          )
        );
      }

      const body = create("div", "cdv-blog__card-body");
      const meta = create("div", "cdv-blog__meta");

      meta.appendChild(
        create("span", "cdv-blog__category", article.blog.title)
      );

      if (article.publishedAt) {
        const date = new Date(article.publishedAt);

        if (!Number.isNaN(date.getTime())) {
          const time = create(
            "time",
            "",
            new Intl.DateTimeFormat("de-AT", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric"
            }).format(date)
          );

          time.dateTime = article.publishedAt;
          meta.appendChild(time);
        }
      }

      const title = create("h2", "cdv-blog__card-title");
      const titleLink = create("a", "", article.title);
      titleLink.href = url;
      title.appendChild(titleLink);

      body.append(meta, title);

      const description = String(
        article.excerpt || article.content || ""
      )
        .replace(/<[^>]*>/g, " ")
        .replace(/\s+/g, " ")
        .trim();

      if (description) {
        body.appendChild(
          create(
            "p",
            "cdv-blog__excerpt",
            description.length > excerptLength
              ? description.slice(0, excerptLength).trimEnd() + "…"
              : description
          )
        );
      }

      const more = create(
        "a", "cdv-blog__read-more", "Beitrag lesen "
      );
      more.href = url;

      const arrow = create("span", "", "↗");
      arrow.setAttribute("aria-hidden", "true");
      more.appendChild(arrow);

      body.appendChild(more);
      card.append(photo, body);

      return card;
    }

    /* Beiträge nach Kategorie und Suche filtern */
    function subset() {
      const words = normalize(input.value)
        .split(/\s+/)
        .filter(Boolean);

      const base = words.length || selected === HUB
        ? all
        : all.filter(article =>
            article.blog.handle === selected
          );

      return base.filter(article => {
        const searchable = normalize([
          article.title,
          article.excerpt,
          article.content,
          article.blog.title,
          article.blog.handle
        ].join(" "));

        return words.every(word => searchable.includes(word));
      });
    }

    /* Inhalte ohne Neuladen austauschen */
    function display() {
      if (!ready) return;

      const list = subset();
      const pages = Math.max(
        1, Math.ceil(list.length / pageSize)
      );

      page = Math.min(Math.max(1, page), pages);

      const start = (page - 1) * pageSize;

      
const visible = list
  .slice(start, start + pageSize)
  .map(makeCard);

visible.forEach((card, index) => {
  const img = card.querySelector(".cdv-blog__card-image");
  if (!img) return;

  img.width = 800;
  img.height = 450;

  if (index < 3) {
    img.loading = "eager";
    img.fetchPriority = index === 0 ? "high" : "auto";
  } else {
    img.loading = "lazy";
    img.fetchPriority = "auto";
  }
});

grid.replaceChildren(...visible);


      count.textContent =
        list.length + " " +
        (input.value.trim()
          ? "Treffer"
          : list.length === 1 ? "Beitrag" : "Beiträge");

      empty.hidden = list.length > 0;
      pager.hidden = pages <= 1;

      $("[data-cdv-page-label]").textContent =
        "Seite " + page + " von " + pages;

      $("[data-cdv-page-prev]").disabled = page === 1;
      $("[data-cdv-page-next]").disabled = page === pages;

      if (nativePager) nativePager.hidden = true;

      const category = blogs.find(b => b.handle === selected);

      heading.textContent = input.value.trim()
        ? "Suchergebnisse"
        : selected === HUB
          ? "Alle Blogbeiträge"
          : "Beiträge zu „" + (category?.title || selected) + "“";

      setStatus(
        input.value.trim()
          ? list.length + " passende Beiträge gefunden."
          : ""
      );

      clear.hidden = !input.value.trim();
    }

    /* Direkt zwischen Kategorien wechseln */
    function switchCategory(handle, push = true) {
      if (!ready) return false;

      if (
        handle !== HUB &&
        !blogs.some(blog => blog.handle === handle)
      ) return false;

      selected = handle;
      root.dataset.cdvCurrent = handle;
      root.dataset.cdvHub = String(handle === HUB);

      input.value = "";
      page = 1;

      renderNav(blogs);

      if (titleEl) {
        titleEl.textContent = handle === HUB
          ? "Weinwissen & Geschichten"
          : blogs.find(b => b.handle === handle)?.title || handle;
      }

      if (push) {
        history.pushState(
          { cdvBlog: true, handle },
          "",
          categoryURL(handle)
        );
      }

      display();
      return true;
    }

    /* Kategorie-Chips ohne Seitenreload */
    nav.addEventListener("click", event => {
      const link = event.target.closest("a.cdv-blog__chip");

      if (!link || !nav.contains(link)) return;

      const url = new URL(link.href, location.href);

      if (
        url.origin !== location.origin ||
        event.ctrlKey ||
        event.metaKey ||
        event.shiftKey ||
        event.altKey ||
        event.button !== 0
      ) return;

      const handle = link.dataset.cdvHandle ||
        url.pathname.split("/").filter(Boolean).pop();

      if (switchCategory(handle)) {
        event.preventDefault();
      }
    });

    /* Browser-Zurück/Vorwärts unterstützen */
    window.addEventListener("popstate", () => {
      const match = location.pathname.match(/\/blogs\/([^/?#]+)/);

      if (match && ready) {
        switchCategory(
          decodeURIComponent(match[1]),
          false
        );
      }
    });

    /* Fallback-Suche ohne API */
    function localSearch() {
      const words = normalize(input.value)
        .split(/\s+/)
        .filter(Boolean);

      let found = 0;

      grid.querySelectorAll("[data-cdv-article]").forEach(card => {
        const text = normalize(
          card.dataset.cdvSearch || card.textContent
        );

        const match = words.every(word => text.includes(word));

        card.hidden = !match;
        if (match) found++;
      });

      count.textContent = found + " Treffer";
      empty.hidden = found !== 0;
      clear.hidden = !input.value.trim();

      if (nativePager) {
        nativePager.hidden = !!input.value.trim();
      }

      setStatus(
        input.value.trim()
          ? found + " Treffer innerhalb der geladenen Seite."
          : ""
      );
    }

    form.addEventListener("submit", event => {
      event.preventDefault();

      if (ready) {
        page = 1;
        display();
      } else {
        localSearch();
      }
    });

    input.addEventListener("input", () => {
      clear.hidden = !input.value.trim();

      if (!input.value.trim()) {
        if (ready) {
          page = 1;
          display();
        } else {
          localSearch();
        }
      }
    });

    clear.addEventListener("click", () => {
      input.value = "";

      if (ready) {
        page = 1;
        display();
      } else {
        localSearch();
      }

      input.focus();
    });

    $("[data-cdv-page-prev]").addEventListener("click", () => {
      if (page > 1) {
        page--;
        display();
      }
    });

    $("[data-cdv-page-next]").addEventListener("click", () => {
      page++;
      display();
    });

    /* Blogdaten nur einmal laden */
    const thisRequest = ++requestId;

    loadData()
      .then(data => {
        if (
          thisRequest !== requestId ||
          !root.isConnected
        ) return;

        blogs = data.blogs.filter(blog =>
          blog &&
          blog.handle &&
          blog.title &&
          blog.onlineStoreUrl
        );

        all = data.articles;
        ready = true;

        try {
          sessionStorage.setItem(
            sessionKey,
            JSON.stringify(blogs)
          );
        } catch (error) {
          // Browserspeicher optional.
        }

        
renderNav(blogs);

// Bereits serverseitig angezeigte Karten beim ersten Laden behalten.
// Verhindert erneutes Rendering der sichtbaren Bilder.
if (grid.children.length === 0) {
  display();
} else {
  count.textContent = initialCount;
  empty.hidden = true;
  pager.hidden = true;
  if (nativePager) nativePager.hidden = false;
}

      })
      .catch(error => {
        if (thisRequest !== requestId) return;

        console.error(
          "Castello del Vino Blogübersicht:",
          error
        );

        grid.innerHTML = originalHTML;
        count.textContent = initialCount;

        pager.hidden = true;

        if (nativePager) nativePager.hidden = false;

        setStatus(
          "Blogübergreifende Daten konnten nicht geladen werden. " +
          "Vorhandene Beiträge bleiben durchsuchbar."
        );
      });
  }

  function run(scope) {
    if (
      scope.matches &&
      scope.matches("[data-cdv-blog-root]")
    ) init(scope);

    if (scope.querySelectorAll) {
      scope.querySelectorAll(
        "[data-cdv-blog-root]"
      ).forEach(init);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => run(document),
      { once: true }
    );
  } else {
    run(document);
  }

  document.addEventListener(
    "shopify:section:load",
    event => run(event.target)
  );
})();
